import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { downloadExcel } from '~/functions/export';
import { IMPACT_CARRY_CONCEPT_ID } from '~/constants/concepts';
import { useGetAccountQuery, useGetImpactGoalQuery, Module, useExportByCompanyLazyQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'EsgExcelExport',
  props: {
    ventureId: {
      type: String,
      required: true
    },
    ventureName: {
      type: String,
      default: undefined
    }
  },
  emits: ['close', 'finish'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var route = useRoute();
    var ventureIdFromRoute = computed(function () {
      return route.params.venture || '';
    });
    var input = ref({
      doExportMetrics: false,
      doExportEsgScores: false,
      doExportEsgQuestions: false,
      doExportImpactAssessment: false,
      doExportImpactCarry: false,
      ventureId: ventureIdFromRoute === null || ventureIdFromRoute === void 0 ? void 0 : ventureIdFromRoute.value
    });
    var _useGetAccountQuery = useGetAccountQuery({
        id: ventureIdFromRoute === null || ventureIdFromRoute === void 0 ? void 0 : ventureIdFromRoute.value
      }),
      result = _useGetAccountQuery.result;
    var hasEsg = computed(function () {
      var _result$value, _result$value$getAcco, _result$value$getAcco2;
      return !!((_result$value = result.value) !== null && _result$value !== void 0 && (_result$value$getAcco = _result$value.getAccount) !== null && _result$value$getAcco !== void 0 && (_result$value$getAcco2 = _result$value$getAcco.bookedModules) !== null && _result$value$getAcco2 !== void 0 && _result$value$getAcco2.includes(Module.Esg));
    });
    var hasImpact = computed(function () {
      var _result$value2, _result$value2$getAcc, _result$value2$getAcc2;
      return !!((_result$value2 = result.value) !== null && _result$value2 !== void 0 && (_result$value2$getAcc = _result$value2.getAccount) !== null && _result$value2$getAcc !== void 0 && (_result$value2$getAcc2 = _result$value2$getAcc.bookedModules) !== null && _result$value2$getAcc2 !== void 0 && _result$value2$getAcc2.includes(Module.ImpactGoal));
    });
    var hasImpactStrategy = computed(function () {
      var _result$value3, _result$value3$getAcc, _result$value3$getAcc2;
      return !!((_result$value3 = result.value) !== null && _result$value3 !== void 0 && (_result$value3$getAcc = _result$value3.getAccount) !== null && _result$value3$getAcc !== void 0 && (_result$value3$getAcc2 = _result$value3$getAcc.bookedModules) !== null && _result$value3$getAcc2 !== void 0 && _result$value3$getAcc2.includes(Module.ImpactStrategy));
    });
    var _useGetImpactGoalQuer = useGetImpactGoalQuery(computed(function () {
        return {
          ventureId: ventureIdFromRoute.value
        };
      }), computed(function () {
        return {
          enabled: !!ventureIdFromRoute.value && (hasImpact.value || hasImpactStrategy.value)
        };
      })),
      impactGoalResult = _useGetImpactGoalQuer.result;
    var hasImpactCarry = computed(function () {
      var _impactGoalResult$val, _impactGoalResult$val2;
      return (((_impactGoalResult$val = impactGoalResult.value) === null || _impactGoalResult$val === void 0 ? void 0 : (_impactGoalResult$val2 = _impactGoalResult$val.getImpactGoal) === null || _impactGoalResult$val2 === void 0 ? void 0 : _impactGoalResult$val2.impacts) || []).some(function (impact) {
        return Number(impact.conceptId) === IMPACT_CARRY_CONCEPT_ID;
      });
    });
    var _useExportByCompanyLa = useExportByCompanyLazyQuery({
        input: input.value,
        fetchPolicy: 'network-only'
      }),
      onResult = _useExportByCompanyLa.onResult,
      refetch = _useExportByCompanyLa.refetch,
      loading = _useExportByCompanyLa.loading,
      load = _useExportByCompanyLa.load;
    onResult(function (res) {
      var _res$data;
      var file = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.exportByCompany.file;
      if (file) {
        downloadExcel(file, "".concat(props.ventureName, ".xlsx"));
        emit('finish');
      }
    });
    var triggerExcelExport = function triggerExcelExport() {
      load(null, {
        input: input.value
      }) || refetch({
        input: input.value
      });
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      route: route,
      ventureIdFromRoute: ventureIdFromRoute,
      input: input,
      result: result,
      hasEsg: hasEsg,
      hasImpact: hasImpact,
      hasImpactStrategy: hasImpactStrategy,
      impactGoalResult: impactGoalResult,
      hasImpactCarry: hasImpactCarry,
      onResult: onResult,
      refetch: refetch,
      loading: loading,
      load: load,
      triggerExcelExport: triggerExcelExport
    };
  }
});